export const reduceAddonPrices = (rentalItem) => {
    if (!rentalItem.add_ons) {
        return 0;
    }
    return rentalItem.add_ons.reduce((total, addon) => total + addon.price, 0);
};
